import { Card, Divider, FormGroup, H4, H5, InputGroup } from '@blueprintjs/core'
import { SKELETON } from '@blueprintjs/core/lib/esm/common/classes'
import { IconNames } from '@blueprintjs/icons'

export default (props: {
}) => <>
        <H4 className={SKELETON}>Lorem ipsum dolor sit amet</H4>
        <H5 className={SKELETON}>Lorem ipsum dolor sit amet</H5>
        <Card compact>
            <H4 className={SKELETON}>Lorem ipsum dolor sit amet</H4>
            <Divider />
            <FormGroup
                className={SKELETON}
                label="Lorem ipsum"
                labelFor="lremIpsumInput1">
                <InputGroup
                    id="lremIpsumInput1"
                    className={SKELETON}
                    type="text"
                    leftIcon={IconNames.Square}
                    value="Lorem ipsum"
                    readOnly />
            </FormGroup>
            <FormGroup
                className={SKELETON}
                label="Lorem ipsum"
                labelFor="lremIpsumInput2">
                <InputGroup
                    id="lremIpsumInput2"
                    className={SKELETON}
                    type="text"
                    leftIcon={IconNames.Square}
                    value="Lorem ipsum"
                    readOnly />
            </FormGroup>
            <FormGroup
                className={SKELETON}
                label="Lorem ipsum"
                labelFor="lremIpsumInput3">
                <InputGroup
                    id="lremIpsumInput3"
                    className={SKELETON}
                    type="text"
                    leftIcon={IconNames.Square}
                    value="Lorem ipsum"
                    readOnly />
            </FormGroup>
            <FormGroup
                className={SKELETON}
                label="Lorem ipsum"
                labelFor="lremIpsumInput4">
                <InputGroup
                    id="lremIpsumInput4"
                    className={SKELETON}
                    type="text"
                    leftIcon={IconNames.Square}
                    value="Lorem ipsum"
                    readOnly />
            </FormGroup>
            <FormGroup
                className={SKELETON}
                label="Lorem ipsum"
                labelFor="lremIpsumInput5">
                <InputGroup
                    id="lremIpsumInput5"
                    className={SKELETON}
                    type="text"
                    leftIcon={IconNames.Square}
                    value="Lorem ipsum"
                    readOnly />
            </FormGroup>
            <FormGroup
                className={SKELETON}
                label="Lorem ipsum"
                labelFor="lremIpsumInput6">
                <InputGroup
                    id="lremIpsumInput6"
                    className={SKELETON}
                    type="text"
                    leftIcon={IconNames.Square}
                    value="Lorem ipsum"
                    readOnly />
            </FormGroup>
        </Card>
    </>